import React from 'react';
import classes from './EndCall.module.css'

const EndCall = (props) => {
    return (
        <>
            <i className={classes.phone}  onClick={props.onPhoneClick}></i>
        </>
    );
};
export default EndCall
